import { render, staticRenderFns } from "./Condizioni-generali.vue?vue&type=template&id=658c05de&scoped=true&"
import script from "./Condizioni-generali.vue?vue&type=script&lang=js&"
export * from "./Condizioni-generali.vue?vue&type=script&lang=js&"
import style0 from "./Condizioni-generali.vue?vue&type=style&index=0&id=658c05de&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c05de",
  null
  
)

export default component.exports